


/* Copyright (c) Trimble Inc. All rights reserved. */
import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React, { memo } from 'react';

export const ExpandCircleDown: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      {...props}
      width="20" height="20" viewBox="0 0 20 20" 
      fill="none"
    >
        <g clipPath="url(#clip0_1779_18716)">
        <path d="M9.99935 1.66406C5.39935 1.66406 1.66602 5.3974 1.66602 9.9974C1.66602 14.5974 5.39935 18.3307 9.99935 18.3307C14.5993 18.3307 18.3327 14.5974 18.3327 9.9974C18.3327 5.3974 14.5993 1.66406 9.99935 1.66406ZM9.99935 12.9141L6.24935 9.16406L7.43268 7.98906L9.99935 10.5557L12.566 7.98906L13.7493 9.16406L9.99935 12.9141Z" fill={props.color}/>
        </g>
        <defs>
        <clipPath id="clip0_1779_18716">
        <rect width="20" height="20" fill="white"/>
        </clipPath>
        </defs>
</SvgIcon>
  );
};

export default memo(ExpandCircleDown);
